import { render, staticRenderFns } from "./SelectorMotivos.vue?vue&type=template&id=51f99fd3"
import script from "./SelectorMotivos.vue?vue&type=script&lang=js"
export * from "./SelectorMotivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports